import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import DetailView from './View';
import withAlert from '../../../../../utils/composition/withAlert';
import DetailWraper from '../../received/detail/DetailedStyled';
import { DialogFormWrapper } from '../../../../common';
import { formConfig } from '../../received/detail/config';
import { EVENT_OPERATION } from '../../../../../data/enums/EventOperation';
import PromotionForm from '../../received/detail/promotion/PromotionForm';
import BillDiscountView from '../../received/detail/billDiscount';

const propTypes = {
  loading: PropTypes.bool,
  activeLine: PropTypes.shape({
    id: PropTypes.number,
    sellerId: PropTypes.number,
  }),
  data: PropTypes.instanceOf(Array),
  onRowClick: PropTypes.func.isRequired,
  selectedOrders: PropTypes.instanceOf(Array),
  onOrderStatusChangeClick: PropTypes.func.isRequired,
  checkBoxStatus: PropTypes.func,
  onPrimaryCheckBoxClick: PropTypes.func,
  onSecondaryCheckBoxClick: PropTypes.func,
};

const defaultProps = {
  data: [],
  activeLine: {
    id: '',
    sellerId: 0,
  },
  selectedOrders: [],
  loading: false,
  checkBoxStatus: () => null,
  onPrimaryCheckBoxClick: () => null,
  onSecondaryCheckBoxClick: () => null,
};

class Detail extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    return { data: nextProps.data };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = {
      dialog: {
        type: '',
        element: '',
      },
    };
  }

  componentDidMount() {}

  handleIconClick = (type, element = {}) => {
    this.setState({
      dialog: {
        type,
        element,
      },
    });
  };

  resetDialog = () => {
    this.setState({
      dialog: {
        type: '',
        element: '',
      },
    });
  };

  render() {
    const { dialog } = this.state;
    const { type } = dialog;
    const {
      data,
      activeLine,
      onRowClick,
      selectedOrders,
      checkBoxStatus,
      onOrderStatusChangeClick,
      onPrimaryCheckBoxClick,
      onSecondaryCheckBoxClick,
      loading,
    } = this.props;

    return (
      <Fragment>
        <DetailWraper>
          <div className={type.toLowerCase()}>
            {type && (
              <DialogFormWrapper
                formConfig={formConfig[type]}
                dialogElement={dialog.element}
                onDialogSubmit={() => null}
                onDialogCancel={this.resetDialog}
                type={type}
                renderDialog={({ dialogData }) => (
                  <Fragment>
                    {type === EVENT_OPERATION.READ && <PromotionForm data={dialogData} loading={loading} />}
                    {type === EVENT_OPERATION.READ_SUB_TYPE && <BillDiscountView data={dialogData} loading={loading} />}
                  </Fragment>
                )}
              />
            )}
          </div>
        </DetailWraper>
        <DetailView
          data={data}
          onRowClick={onRowClick}
          onIconClick={this.handleIconClick}
          activeLine={activeLine}
          selectedOrders={selectedOrders}
          checkBoxStatus={checkBoxStatus}
          onPrimaryCheckBoxClick={onPrimaryCheckBoxClick}
          onSecondaryCheckBoxClick={onSecondaryCheckBoxClick}
          onOrderStatusChangeClick={onOrderStatusChangeClick}
          loading={loading}
        />
      </Fragment>
    );
  }
}

Detail.propTypes = propTypes;

Detail.defaultProps = defaultProps;

export default withAlert()(Detail);
